<template>
  <IntercomTopbar
    :app-name="appName"
    :product-name="productName"
    :business-name="businessName"
    :user="user"
    :global-user="globalUser"
    :search-placeholder="searchPlaceholder"
    :search-fn="searchFn"
    @select-result="handleSelectResult"
    @notifications="$emit('notifications')"
    @settings="$emit('settings')"
    @logout="$emit('logout')"
  />
</template>

<script setup>
import { IntercomTopbar } from '@shared/components/intercom'

const props = defineProps({
  appName: { type: String, default: 'OnePlaceHQ' },
  productName: { type: String, default: 'Faraid' },
  businessName: { type: String, default: '' },
  user: { type: Object, default: () => ({}) },
  globalUser: { type: Object, default: () => ({}) },
  searchPlaceholder: { type: String, default: 'Search cases, scholars...' },
  searchFn: { type: Function, default: null },
})

const emit = defineEmits(['select-case', 'select-scholar', 'notifications', 'settings', 'logout'])

const handleSelectResult = (result) => {
  if (result.type === 'case') {
    emit('select-case', result)
  } else if (result.type === 'scholar') {
    emit('select-scholar', result)
  }
}
</script>
